import React from 'react';
import './ResultListSkeleton.scss';

interface ResultListSkeletonProps {
  cardColumns?: number;
}

const ResultListSkeleton: React.FC<ResultListSkeletonProps> = ({
  cardColumns = 4,
}) => {
  const skeletonItemCounter = (count: number) => Array.from({ length: count });

  return (
    <div
      className={`skeleton-card-grid skeleton-card-grid--cols-${cardColumns}`}
    >
      {skeletonItemCounter(8).map((_, index) => (
        <div key={index} className="skeleton-card">
          {/* Thumbnail skeleton */}
          <div className="skeleton-card__thumbnail shimmer"></div>

          <hr className="skeleton-card__divider" />

          {/* Content skeleton */}
          <div className="skeleton-card__content">
            {/* Title */}
            <div className="skeleton-card__title shimmer"></div>

            {/* Meta fields */}
            <div className="skeleton-card__meta">
              <div className="skeleton-card__meta-row">
                <div className="skeleton-card__meta-label shimmer"></div>
                <div className="skeleton-card__meta-value shimmer"></div>
              </div>
              <div className="skeleton-card__meta-row">
                <div className="skeleton-card__meta-label shimmer"></div>
                <div className="skeleton-card__meta-value shimmer"></div>
              </div>
              <div className="skeleton-card__meta-row">
                <div className="skeleton-card__meta-label shimmer"></div>
                <div className="skeleton-card__meta-value shimmer"></div>
              </div>
            </div>

            <hr className="skeleton-card__divider" />

            {/* Tools button */}
            <div className="skeleton-card__actions">
              <div className="skeleton-card__btn shimmer"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ResultListSkeleton;
